import { useState, useEffect, useContext } from 'react'
import { Link, useLocation, useParams } from 'react-router-dom';
import { useQuery } from "react-query";
import { useTranslation } from "react-i18next";


import './css/fav.css'

import { AppContext } from "../../Context";
import Fetch, { Loader, GET } from "../../inc/Fetch"; 
import Header from "./Header";
import QuestionsList from './components/questionsList'

export default function Start({action}) {

    const { t } = useTranslation();
    let location = useLocation();
    let params = useParams();

    const { successData, cartData } = useContext(AppContext);
    const [open, setopen] = successData;
    const [cart, setcart] = cartData;

    const [questions, setquestions] = useState([]);


    const [loader, setloader] = useState(false);

    async function loadData() {

        let r = await GET(`task/favList`);
        
        return r;
    }

    const { data, error, isLoading, refetch } = useQuery(`fav`, loadData); 

    function selectAll(e) {
        let ck = e?.target?.checked;
        if (ck) {
            let arr = [];
            data?.map(v => {
                arr.push(v?.data);
            });
            setquestions(arr);
        } else {
            setquestions([]);
        }
       
    } 

    function deleteFav() {


        let conf = window.confirm(t("error",  { returnObjects: true })[2]);
        if (!conf) {
            return false;
        }

        setloader(true);

        let arr = [];
        questions?.map(v => {
            arr.push(v?.id);
        });
        
    
        Fetch("task/deleteFav", (d) => {
            if (d?.error) {
                setopen({
                    short:t("error",  { returnObjects: true })[d?.error],
                    error:true
                });
            } else {
                setquestions([]);
                setcart(p => {

                    let arr2 = [];
                    p?.map(v => {
                        
                        let ck = arr?.filter(d => d == v );
                        if (!ck?.length) {
                            arr2.push(v);
                        } 
                        
                    });
                    return arr2
                });
                refetch();
            }
            setloader(false);
        }, arr);
    }


    if (isLoading) {
        return <Loader />
    }
    
    return (
        <>
            {questions?.length ? <div className='favCpBox'>
                <Link to='/sendTask' state={{ previousLocation: location, questions:questions }} className='btn'>{t("tasks_send_now")} ({questions?.length})</Link>
                <a onClick={deleteFav} className='btn gray'>{t("delete")} ({questions?.length})</a>
            </div>: false}
            {loader && <Loader />}
            <div className='taskNewBody' style={{paddingBottom:100}}>
                
                <Header />

                
                <div className={`mainWidth taskMainNewBox`}>
                    <div className='mainTitleBox'>
                        <div>
                            <h1 className='mainTitle'>{t("header_user_menu_6")}</h1>
                            {/* <nav>
                                <a className='tagInfo'>{data?.task?.cat?.name}</a>
                            
                                {data?.task?.classes?.map((v, k) => {

                                    return (
                                        <a key={k} className='tagInfo'>{t("class")} {global?.Classes[v]}</a>
                                    )
                                })}
                                
                            </nav> */}
                        </div>
                        
                        
                    </div>
                

                    <div className='questionsBoxNewTitle'>
                        <hr />
                        <span>{t("tasks_questions_number")} ({data?.length})</span>
                        <hr />
                    </div>

                    

                    <div className='favQuestionBox'>
                        {data?.length ? <table className='table h-border same-color'>
                            <thead>
                                <tr>
                                    <td style={{width:30}}>#</td>
                                    <td className='text-right'>{t("task_question")}</td>
                                    <td style={{width:110}}>{t("task_type")}</td>
                                    <td style={{width:80}}><input type='checkbox' className='tableCheck' onChange={selectAll} /></td>
                                </tr>
                            </thead>


                            <tbody>

                                {data?.map((v, k) => {
                                    return (
                                        <>
                                            <QuestionsList fav={true} v={v?.data} k={k + 1} key={k} setquestions={setquestions} questions={questions}/>
                                        </>
                                    );
                                })}
                            </tbody>
        

                        </table>:
                            <div className='noData'>{t("error",  { returnObjects: true })[1]}</div>
                        }
                    </div>
                   
                </div>
               
            </div>

        </>
    )
}
